import { render, staticRenderFns } from "./ProductPriceBreakdown.vue?vue&type=template&id=0b73f668&scoped=true&"
import script from "./ProductPriceBreakdown.vue?vue&type=script&lang=js&"
export * from "./ProductPriceBreakdown.vue?vue&type=script&lang=js&"
import style0 from "./ProductPriceBreakdown.vue?vue&type=style&index=0&id=0b73f668&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0b73f668",
  null
  
)

export default component.exports